 <template>
<div>
  <v-row class="mb-3">
      <v-col class="text-right">
         <v-btn
        class="ml-2"
          color="primary"
          outlined
          large
          :href="url"
          target="_blank"
        >
          View Report
        </v-btn>
        <v-btn
        class="ml-2"
          color="primary"
          large
          :to="{
            name: 'PageModeratorPlayerMissionAdd',
            params: { parentId: parent.id },
          }"
        >
          + Add Mission
        </v-btn>
      </v-col>
    </v-row>
  <!-- BOC:[table] -->
  <BreadBrowseTable
    role="Moderator"
    :model="model"
    :url="`${$api.servers.game}/api/v1/${this.$_getLocale()}/moderator/player/${parent.id}/mission`"
    :isSearchable="true"
    :parent="parent"
    :modelParent="modelParent"
  ></BreadBrowseTable>
  <!-- EOC -->
</div>
</template>

<script>
  //BOC:[model]
  import modelParent from '@/models/items/player'
  import model from '@/models/items/playerMission'
  //EOC
  //BOC:[table]
  import BreadBrowseTable from '@/components/Bread/BreadBrowseTableV2'
  //EOC
  import { mapState } from 'vuex'
  export default {
    components:{
      //BOC:[table]
      BreadBrowseTable,
      //EOC
    },
    computed: mapState({
      school: state => state.school.data,
    }),
    props:[
      'role',
      'parent',
    ],
    data:()=>({
      //BOC:[model]
      modelParent:modelParent,
      model: model,
      //EOC
      url:null
    }),
    created() {
      //
    },
    mounted() {
      this.url = `${process.env.VUE_APP_URL_WEB_SCHOOL}/${this.$_getLocale()}/mission/${this.parent.mochiId}`;
    },
    methods: {
      //
    }
  }
</script>